import { ProgressBarMode } from '.';
import styled, { css } from 'styled-components';

import theme from '@/theme';

import { device, typography } from '@/styles/helpers';

export const ScProgressBar = styled.div<{
  small?: boolean;
  progress: string;
  isPassedSuperSpotBreakpoint?: boolean;
}>`
  padding: 8px 0;
  max-width: 800px;
  width: 100%;

  & > .progress-line {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    height: ${({ small }) => (small ? '24px' : '32px')};
    border-radius: 360px;
    background: ${({ theme }) => theme.whiteColor};

    &::after {
      content: '';
      position: absolute;
      inset: 2px;
      border-radius: ${({ progress }) => {
        const value = +progress.replace('%', '');
        return `360px ${value > 99 ? '360px 360px' : '0 0'} 360px`;
      }};
      width: calc(${({ progress }) => progress} - 4px);
      background: ${({ isPassedSuperSpotBreakpoint, theme }) =>
        isPassedSuperSpotBreakpoint
          ? `linear-gradient(90deg, ${theme.vipSuper1} 0%, ${theme.vipSuper2} 50%, ${theme.vipSuper3} 100%)`
          : 'linear-gradient(90deg, #ffad01 19.02%, #ffd500 100%)'};
    }

    .breackpoint {
      z-index: 1;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  @media (${device.mobile}) {
    padding: 4px 0;
    max-width: auto;
  }
`;

interface ScCoin {
  small?: boolean;
  mode: ProgressBarMode;
}

export const ScCoin = styled.div<ScCoin>`
  display: flex;
  height: ${({ small }) => (small ? '32px' : '48px')};
  width: ${({ small }) => (small ? '32px' : '48px')};
  position: relative;

  justify-content: center;
  align-items: center;
  border-radius: 360px;
  cursor: pointer;

  ${({ mode }) => {
    switch (mode) {
      case 'passed':
        return css`
          border: 2px solid #ffd500;
          background: linear-gradient(
            180deg,
            #ffd500 0%,
            #ffad01 51.13%,
            #bd5d0d 105.56%
          );
          box-shadow:
            0px 0px 12px 0px #bd5d0d inset,
            0px 0px 1px 0px rgba(91, 51, 5, 0.7),
            0px 0px 5px 0px rgba(91, 51, 5, 0.7);
        `;
      case 'passedSuper':
        return css`
          border: 2px solid transparent;
          background: ${({ theme }) =>
            `linear-gradient(180deg, ${theme.vipSuper1} 0%, ${theme.vipSuper2} 100%) padding-box,
            linear-gradient(180deg, ${theme.vipSuper1} 0%, ${theme.vipSuper2} 100%) border-box
          `};

          box-shadow:
            0px 0px 12px 0px #000 inset,
            0px 0px 1px 0px rgba(0, 0, 0, 0.7),
            0px 0px 5px 0px rgba(0, 0, 0, 0.7);
        `;
      case 'future':
        return css`
          border: 2px solid rgba(0, 0, 0, 0.05);
          background: ${({ theme }) => theme.whiteColor};
          box-shadow:
            -2px 0px 10px 0px rgba(0, 0, 0, 0.2),
            -2px 0px 20px 0px rgba(0, 0, 0, 0.2);
        `;
    }
  }}
  p {
    color: ${({ theme }) => theme.blackColor};
    ${({ small }) =>
      small ? typography['caption2bold'] : typography['body1bold']}
    z-index: 2;

    span {
      ${({ small }) =>
        small ? typography['caption1bold'] : typography['caption2bold']}
    }
  }

  .progressBoostedIcon {
    position: absolute;
    top: -10px;
    left: 24px;
    border-radius: 100%;

    ${({ small }) =>
      small &&
      css`
        top: -8px;
        left: 18px;
      `}
  }

  ${({ small }) =>
    !small &&
    css`
      @media (${device.mobile}) {
        width: 40px;
        height: 40px;

        p {
          ${typography['body2bold']}

          span {
            ${typography['caption1bold']}
          }
        }
      }
    `}
`;

export const overlayStyle = {
  opacity: '1',
  borderRadius: '12px',
  zIndex: 10,
};

export const overlayInnerStyle = {
  background: theme.whiteColor,
  maxWidth: '240px',
  borderRadius: '12px',
  border: 'none',
  color: theme.blackColor,
  fontSize: '14px',
  lineHeight: '20px',
  textAlign: 'center' as const,
  wordBreak: 'break-word' as const,
  boxShadow: `0px 0px 10px 0px rgba(0, 0, 0, 0.40), 0px 0px 20px 0px rgba(0, 0, 0, 0.40)`,
};
